import { FC, useEffect, useState } from 'react';

import { Button, Flex, Text, Title, Tooltip } from '@mantine/core';
import { randomId, useDisclosure } from '@mantine/hooks';

import useAppStore from '@/shared/store/app.store.ts';
import { BottomSheet } from '@/shared/uikit/components/bottomSheet';
import { ModalSheet } from '@/shared/uikit/components/modalSheet';

import { IconBell } from '@tabler/icons-react';

import { getPermission } from '@/configs/serviceworker-registration.ts';

export const PushNotificationButton: FC = () => {
	const { isMobile } = useAppStore();
	const [isLoading, setIsLoading] = useState(false);
	const [isDeniedPushNotification, setIsDeniedPushNotification] = useState(false);
	const [showPushNotification, setShowPushNotification] = useState(false);
	const [openedNotificationModal, { close: closeNotificationModal, open: openNotificationModal }] =
		useDisclosure(false);

	const handleGetPermission = async () => {
		try {
			setIsLoading(true);
			const permission = await getPermission().then((res) => res);

			switch (permission) {
				case 'denied': {
					setIsDeniedPushNotification(true);
					break;
				}
				case 'granted': {
					setShowPushNotification(true);
					break;
				}
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsLoading(false);
			closeNotificationModal();
		}
	};

	useEffect(() => {
		void handleGetPermission();
	}, []);

	const content = (
		<>
			<IconBell size={64} color={'#bdbdbd'} />
			<Title order={4} ta={'center'}>
				Советуем включить пуш-уведомления
			</Title>
			<Text c={'dimmed'} w={'75%'} mx={'auto'}>
				Они будут приходить как обычно и помогут не пропустить важное о ваших бронированиях
			</Text>
		</>
	);

	const buttons = [
		{
			id: randomId(),
			children: 'Не сейчас',
			variant: 'default',
			onClick: closeNotificationModal,
		},
		{
			id: randomId(),
			children: 'Включить',
			loading: isLoading,
			onClick: handleGetPermission,
		},
	];

	return (
		<>
			{isDeniedPushNotification ? (
				<Tooltip label={'Доступ к уведомлениям заблокирован настройками устройства'}>
					<Button disabled>Недоступно</Button>
				</Tooltip>
			) : (
				<Button size={'md'} {...(!showPushNotification ? { onClick: openNotificationModal } : {})}>
					{showPushNotification ? 'Включено' : 'Включить'}
				</Button>
			)}

			{isMobile ? (
				<BottomSheet
					opened={openedNotificationModal}
					onClose={closeNotificationModal}
					withBackButton={false}
				>
					<Flex direction={'column'} align={'center'} gap={'sm'}>
						{content}
						{buttons?.map((button) => (
							<Button key={button.id} {...button} size={'md'} fullWidth>
								{button?.children}
							</Button>
						))}
					</Flex>
				</BottomSheet>
			) : (
				<ModalSheet
					opened={openedNotificationModal}
					onClose={closeNotificationModal}
					buttons={buttons}
					buttonsDirection={'column'}
				>
					<Flex direction={'column'} align={'center'} gap={'sm'}>
						{content}
					</Flex>
				</ModalSheet>
			)}
		</>
	);
};
